import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchQuestionnaireSchema, } from '@/entities/feedback-item';
import { submitQuestionnaireAction } from '@/features/submit-questionnaire';
import { ApiError } from '@/shared/api';
import { uiCopy } from '@/shared/copy';
import { Alert, AlertDescription, AlertTitle, Button, Skeleton, } from '@/shared/ui';
export function AgentQuestionnairePage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [schema, setSchema] = useState(null);
    const [values, setValues] = useState({});
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        void (async () => {
            try {
                setSchema(await fetchQuestionnaireSchema());
            }
            catch (err) {
                setError(err instanceof ApiError ? err.message : uiCopy.loadFailed);
            }
            finally {
                setLoading(false);
            }
        })();
    }, []);
    if (loading) {
        return (_jsx("div", { className: "p-6", children: _jsx(Skeleton, { className: "h-64 w-full" }) }));
    }
    return (_jsxs("div", { className: "mx-auto max-w-xl space-y-4 p-4 md:p-6", children: [_jsx("h1", { className: "text-xl font-semibold", children: schema?.title ?? 'Анкета агента' }), error ? (_jsxs(Alert, { variant: "destructive", children: [_jsx(AlertTitle, { children: uiCopy.errorTitle }), _jsx(AlertDescription, { children: error })] })) : null, _jsxs("form", { className: "space-y-4", onSubmit: (e) => {
                    e.preventDefault();
                    if (!id)
                        return;
                    void (async () => {
                        setBusy(true);
                        setError(null);
                        try {
                            const answers = { ...values };
                            if (values.experienceYears !== undefined) {
                                answers.experienceYears = Number(values.experienceYears);
                            }
                            await submitQuestionnaireAction(id, answers);
                            navigate(`/agents/${id}`);
                        }
                        catch (err) {
                            setError(err instanceof ApiError ? err.message : uiCopy.actionFailed);
                        }
                        finally {
                            setBusy(false);
                        }
                    })();
                }, children: [schema?.fields.map((field) => (_jsxs("label", { className: "block text-sm", children: [field.label, field.type === 'textarea' ? (_jsx("textarea", { className: "mt-1 w-full rounded-md border border-input p-2", required: field.required, value: values[field.name] ?? '', onChange: (e) => setValues((prev) => ({ ...prev, [field.name]: e.target.value })) })) : (_jsx("input", { className: "mt-1 w-full rounded-md border border-input p-2", type: field.type === 'number' ? 'number' : 'text', required: field.required, value: values[field.name] ?? '', onChange: (e) => setValues((prev) => ({ ...prev, [field.name]: e.target.value })) }))] }, field.name))), _jsx(Button, { type: "submit", disabled: busy, children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0430\u043D\u043A\u0435\u0442\u0443" })] })] }));
}
